module.exports = __webpack_public_path__ + "static/media/customer.541080d9.png";